import { FormsModule } from '@angular/forms';
import { RegistNutrientInfoService } from './api-services/regist-nutrient-info.service';
import { GetGoodsNutrientComponentListService } from './api-services/get-goods-nutrient-component-list.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1107Component } from './kymw1107.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * 商品栄養成分情報メンテナンス画面 モジュール設定クラス
 *
 * @export SampleWindowModule
 * @class SampleWindowModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1107Component,
  ],
  providers: [
    GetGoodsNutrientComponentListService,
    RegistNutrientInfoService
  ],
})
export class KYMW1107Module { }
